export default __webpack_public_path__ + "static/universite-sherbrooke-60803ab15a5129d7cf3f7a16065847bb.png";